module.exports = __webpack_public_path__ + "static/media/skip-forward-alt.3f267a9e.svg";